import Vue from 'vue'

export const pricing = async function(line, source, customer, taxes) {
  // LCBO Direct Delivery pricing
  if (customer?.type === 'LCBODutyPaid' && line.cases && source.customers[0]) {
    line.unitPrice = source.customers[0].price / source.caseSize;
    line.taxCodeId = source.customers[0].tax.id;
  }

  else if (line.inBondProduct && line.cases && customer?.type === 'DutyFree') {
    if (!source.dutyFreePrice) {
      const results = await Vue.prototype.$apiCall(`query OntarioPricing($input:OntarioDutyFreePriceInput!) {
                                              ontarioDutyFreePrice(input:$input)
                                            }`,
                                            {input:{lcboPrice:source.defaultBondedPrice, cooler:false}});
      if (!results.error)
        source.dutyFreePrice = results.data.ontarioDutyFreePrice;
    }
    line.unitPrice = source.dutyFreePrice;
  }

  else if (customer?.type ===  'Licensee' ||  customer?.type === 'TiedHouse' || customer?.type === 'ByTheGlass') {
    if (!source.licenseePrice) {
      const results = await Vue.prototype.$apiCall(`query OntarioPricing($input: OntarioLicenseePriceInput!) {
                                              ontarioLicenseePrice(input:$input)
                                            }`,
                                            {input:{retailPrice:source.defaultPrice, bottleSize:source.bottleSize}});
      if (!results.error)
        source.licenseePrice = results.data.ontarioLicenseePrice;
    }
    line.unitPrice = source.licenseePrice;
  }

  if (['DutyFree','Licensee','TiedHouse','ByTheGlass','SpecialOccasionPermit','None'].includes(customer?.type))
    line.taxCodeId = taxes.find(tax => tax.name === 'Exempt')?.id;
}